import { render, staticRenderFns } from "./SmsRecords.vue?vue&type=template&id=2b3d9548&scoped=true"
import script from "./SmsRecords.vue?vue&type=script&lang=js"
export * from "./SmsRecords.vue?vue&type=script&lang=js"
import style0 from "./SmsRecords.vue?vue&type=style&index=0&id=2b3d9548&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3d9548",
  null
  
)

export default component.exports